import { Dispatch, SetStateAction } from 'react';

import { AuthModal } from 'interfaces/auth';

export interface IResetFormData {
  email: string;
  code: string;
  password: string;
  confirmPassword: string;
}

export interface ISetUpData {
  email: string;
  password: string;
}

export interface IAuthContext {
  resetFormData: IResetFormData;
  isModalOpened: boolean;
  setResetFormData: Dispatch<SetStateAction<IResetFormData>>;
  setAuthModal: (modal: AuthModal) => void;
  setIsModalOpened: Dispatch<SetStateAction<boolean>>;
  modalError: modalErrorType;
  setModalError: Dispatch<SetStateAction<modalErrorType>>;
  setUpData: ISetUpData;
  changeSetUpData: Dispatch<SetStateAction<ISetUpData>>;
}

export const MODAL_ERRORS = {
  REGISTRATION_ERROR: 'registrationError',
  LOGIN_ERROR: 'loginError',
};

export type modalErrorType = (typeof MODAL_ERRORS)[keyof typeof MODAL_ERRORS] | null;
